import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login'
import StudentMain from '@/components/student'
import teachMain from '@/components/teach'
import Kaoshi from '@/components/kaoshi/kaoshi.vue'
import zaixianlianxi from '@/components/studentpage/zxlianxi.vue'
import ksxz from '@/components/kaoshi/ksxz.vue'
import jiankaolist from '@/components/teacherpage/jiankaolist.vue'
import person from '@/components/person.vue'
import message from '@/components/message.vue'
import facecheck from '@/components/facecheck.vue'
import changpass from '@/components/pages/changPass.vue'
import Examination from '@/components/examonline/examination.vue'
import jiankaoindex from '@/components/teacherpage/jiankaoindex.vue'
import yuejuanlist from '@/components/teacherpage/yuejuanlist.vue'
import yuejuanmx from '@/components/teacherpage/yuejuanmx.vue'
import yuejuanindx from '@/components/teacherpage/yuejuanindx.vue'
import cuotiji from '@/components/teacherpage/cuotiji.vue'
import cuotiku from '@/components/studentpage/cuotiku.vue'
import myshoucang from "@/components/studentpage/myshoucang.vue";
import studentcj from "@/components/studentpage/studentcj.vue";
import chengjicx from "@/components/teacherpage/chengjicx.vue";
import mypaper from "@/components/teacherpage/mypaper.vue";
import mypaperindex from "@/components/teacherpage/mypaperindex.vue";
import stceyan from "@/components/studentpage/stceyan.vue";
import stceyantecher from "@/components/teacherpage/stceyantecher.vue";
import mypaperfile from "@/components/teacherpage/mypaperfile.vue";
import lianxiindex from "@/components/studentpage/lianxiindex.vue";
import usermsg from "@/components/usermsg.vue";
import suitangindex from '@/components/teacherpage/suitangindex.vue'
import suitangksindex from '@/components/teacherpage/suitangksindex.vue'
import suitangreadindex from '@/components/teacherpage/suitangreadindex.vue'
import suitangexam from '@/components/suitangexam/suitangexam.vue'
import paperlq from "@/components/paperlq.vue";
import ckshindex from '@/components/teacherpage/ckshindex.vue'
import ckshdo from '@/components/teacherpage/ckshdo.vue'
import sjshindex from '@/components/teacherpage/sjshindex.vue'
import stshindex from '@/components/teacherpage/stshindex.vue'
import stshdo from '@/components/teacherpage/stshdo.vue'
import sjshdo from '@/components/teacherpage/sjshdo.vue'
import sjshfile from "@/components/teacherpage/sjshfile.vue";

Vue.use(Router)

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/changpass',
      name: 'changpass',
      component: changpass
    },
    {
      path: '/ksxz',
      name: 'ksxz',
      component: ksxz
    },
    {
      path: '/facecheck',
      name: 'facecheck',
      component: facecheck
    },
    {
      path: '/person',
      name: 'person',
      component: person
    },
    {
      path: '/message',
      name: 'message',
      component: message
    },
    {
      path: '/studentmain',
      name: 'studentmain',
      component: StudentMain
    },
    {
      path: '/teachmain',
      name: 'teachmain',
      component: teachMain
    },
    {
      path: '/kaoshi',
      name: 'kaoshi',
      component: Kaoshi
    },
    {
      path: '/examination',
      name: 'kaikao',
      component: Examination
    },

    {
      path: '/zaixianlianxi',
      name: 'zaixianlianxi',
      component: zaixianlianxi
    },
    {
      path: '/jiankaolist',
      name: 'jiankaolist',
      component: jiankaolist
    },
    {
      path: '/jiankaoindex',
      name: 'jiankaoindex',
      component: jiankaoindex
    },
    {
      path: '/yuejuanlist',
      name: 'yuejuanlist',
      component: yuejuanlist
    },
    {
      path: '/yuejuanmx',
      name: 'yuejuanmx',
      component: yuejuanmx
    },
    {
      path: '/yuejuanindx',
      name: 'yuejuanindx',
      component: yuejuanindx
    },
    {
      path: '/cuotiji',
      name: 'cuotiji',
      component: cuotiji
    },
    {
      path: '/cuotiku',
      name: 'cuotiku',
      component: cuotiku
    },
    {
      path: '/myshoucang',
      name: 'myshoucang',
      component: myshoucang
    },
    {
      path: '/studentcj',
      name: 'studentcj',
      component: studentcj
    },
    {
      path: '/chengjicx',
      name: 'chengjicx',
      component: chengjicx
    },
    {
      path: '/mypaper',
      name: 'mypaper',
      component: mypaper
    },
    {
      path: '/mypaperindex',
      name: 'mypaperindex',
      component: mypaperindex
    },
    {
      path: '/stceyan',
      name: 'stceyan',
      component: stceyan
    },
    {
      path: '/stceyantecher',
      name: 'stceyantecher',
      component: stceyantecher
    },
    {
      path: '/mypaperfile',
      name: 'mypaperfile',
      component: mypaperfile
    },
    {
      path: '/lianxiindex',
      name: 'lianxiindex',
      component: lianxiindex
    },
    {
      path: '/usermsg',
      name: 'usermsg',
      component: usermsg
    },
    {
      path: '/suitangindex',
      name: 'suitangindex',
      component: suitangindex
    },
    {
      path: '/suitangksindex',
      name: 'suitangksindex',
      component: suitangksindex
    },
    {
      path: '/suitangreadindex',
      name: 'suitangreadindex',
      component: suitangreadindex
    },
    {
      path: '/suitangexam',
      name: 'suitangexam',
      component: suitangexam
    },
    {
      path: '/paperlq',
      name: 'paperlq',
      component: paperlq
    },
    {
      path: '/ckshindex',
      name: 'ckshindex',
      component: ckshindex
    },
    {
      path: '/ckshdo',
      name: 'ckshdo',
      component: ckshdo
    },
    {
      path: '/stshindex',
      name: 'stshindex',
      component: stshindex
    },
    {
      path: '/stshdo',
      name: 'stshdo',
      component: stshdo
    },
    {
      path: '/sjshindex',
      name: 'sjshindex',
      component: sjshindex
    },
    {
      path: '/sjshdo',
      name: 'sjshdo',
      component: sjshdo
    },
    {
      path: '/sjshfile',
      name: 'sjshfile',
      component: sjshfile
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js